import { Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const BarArea = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 12px;
`;

const GiftItem = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 8px;
  margin-bottom: 16px;

  ${Image.S.Image} {
    border-radius: var(--size-border-radius-md);
    height: 42px;
    width: 42px;
  }
`;

const Rate = styled.div`
  font-weight: bold;
  text-align: right;
  width: 90px;
`;

const ScrollArea = styled.div`
  flex: 1 1 auto;
  max-height: 410px;
  min-height: 100%;
  overflow-y: auto;
`;

const IconWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 2px solid var(--color-bg-weaker);
  border-radius: var(--size-border-radius-circle);
  bottom: -4px;
  display: flex;
  height: 16px;
  justify-content: center;
  position: absolute;
  right: -4px;
  width: 16px;
`;

const ImageWrapper = styled.div`
  height: fit-content;
  position: relative;
`;

export { BarArea, GiftItem, IconWrapper, ImageWrapper, Rate, ScrollArea };
